"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.webRoutes = void 0;
exports.webRoutes = {
    HOME: '/',
    HOME_REVIEW: '/:userId/review',
    FOLLOWING_FEED: '/following-feed',
    REVIEW_DETAIL: '/review/:reviewGroupId',
    REVIEW_COMPLETE: '/review/complete/:reviewGroupId',
    PAYMENT: '/payments',
    REVIEW_EDIT: '/review/edit/:reviewGroupId',
    REVIEW_NEW: '/review/new/visit/:visitId',
    VISIT_DETAIL: '/visit/:visitId',
    SETTING: '/setting',
    SETTING_PROFILE: '/setting/profile',
    HOME_MY_REVIEW: '/review',
    CHECKIN: '/checkin',
    TIMELINE: '/timeline',
    TIMELINE_WITH_DATE: '/timeline?dateRangeFrom=&dateRangeTo=',
    TIMELINE_CANCELED: '/timeline/canceled?tab=',
    MISSION: '/mission',
    REVIEW_FEED: '/:userId/reviewfeed?sort=&mediaFilter=&placeCategoryId=&regionCode=&reviewId=',
};
